import { Component, OnInit } from '@angular/core';
import { ModalNewInvitationService } from '@modules';

@Component({
  selector: 'ggi-journey-client-container',
  templateUrl: './client-container.component.html',
  styleUrls: ['./client-container.component.scss'],
})
export class ClientContainerComponent implements OnInit {
  public modal = false;
  public visitId: string;

  constructor(private modalInvitation: ModalNewInvitationService) {}

  ngOnInit(): void {
    this.modalInvitation.modal.subscribe((res: boolean) => {
      this.modal = res;
    });

    this.modalInvitation.visitId.subscribe((res: string) => {
      this.visitId = res;
    });
  }

  public onActivate(): void {
    window.scroll(0, 0);
  }
}
